import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types'; // Import PropTypes for prop validation
import "./PopeyeHeader.scss";
import { getIcon } from "../../../utils/images";

const PopeyeHeader = ({ totals = {} }) => {
  const [currentDate, setCurrentDate] = useState(new Date().toLocaleString());

  useEffect(() => {
    // Function to update the date and time
    const updateDateTime = () => {
      setCurrentDate(new Date().toLocaleString());
    };

    // Update date and time every second
    const intervalId = setInterval(updateDateTime, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // Destructure totals with default values
  const {
    totalScheduled = 0,
    totalSailing = 0,
    totalDischarged = 0,
    totalDelayed = 0
  } = totals;

  return (
    <div className="PopeyeHeader">
      <div className="subheader">
        <img className="logo" src={getIcon('header-logo')} alt="Header Logo" />
        <div className="date-time">{currentDate}</div>
      </div>
      <div className="subheader_statistics">
        <div className="stat-item-scheduled">
          <div>Scheduled</div>
          <p>{totalScheduled}</p>
        </div>
        <div className="stat-item-sailing" >
          <div>Sailing</div>
          <p>{totalSailing}</p>
        </div>
        <div className="stat-item-discharged" >
          <div>Discharged</div>
          <p>{totalDischarged}</p>
        </div>
        <div className="stat-item-delayed" >
          <div>Delayed</div>
          <p>{totalDelayed}</p>
        </div> 
      </div>
    </div>
  );
}

// PropTypes for validation
PopeyeHeader.propTypes = {
  totals: PropTypes.shape({
    totalScheduled: PropTypes.number,
    totalSailing: PropTypes.number,
    totalDischarged: PropTypes.number,
    totalDelayed: PropTypes.number
  })
};

export default PopeyeHeader;
